export default "__VITE_ASSET__d5ac499a__"